<template>
  <custom-btn-icon
    btn-text="Affectation"
    color="primary"
    icon="search"
    @click.stop="handleClick"
  />
</template>

<script>
import CustomBtnIcon from '@/components/displays/CustomBtnIcon';
import { generateMessage } from '@/utils/i18n';
import { mapActions } from 'vuex';

export default {
  name: 'RequestAffectationBtnDialog',
  components: {
    CustomBtnIcon,
  },
  props: {
    entity_nav_full_id: {
      type: String,
      required: true,
    },
    isAssigned: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPaused: {
      type: Boolean,
      required: false,
      default: false,
    },
    item: {
      type: Object,
      required: false,
    },
    namespace: {
      type: String,
      required: false,
    },
    propertyId: {
      type: Number,
      required: true,
    },
    requestId: {
      type: Number,
      required: true,
    },
    requestOrdo: {
      type: Boolean,
      required: false,
    },
    technician_internal_id: {
      type: Number,
      required: false,
    },
  },
  methods: {
    generateMessage,
    ...mapActions('modal', ['showModal']),
    handleClick() {
      this.showModal({
        componentName: 'RequestAffectationDialog',
        componentProps: {
          entity_nav_full_id: this.entity_nav_full_id,
          isAssigned: this.isAssigned,
          isPaused: this.isPaused,
          item: this.item,
          propertyId: this.propertyId,
          requestId: this.requestId,
          requestOrdo: this.requestOrdo,
          technician_internal_id: this.technician_internal_id,
        },
        dialogProps: {
          width: '80vw',
        },
      });
    },
  },
};
</script>
